export default __webpack_public_path__ + "static/gimlet-6a14891146e86f43cda2ffab6deb759a.svg";